import { useEffect } from "react";
import { Typography, Stack } from '@mui/material';

export const FINALIST_INSTRUCTIONS = [
    "1.	Date and Time:",
    "       •	The final round will take place on May 26 at 10:00 AM to 11:30 AM IST.",
    "       •	Please log in 15 minutes before the start time to ensure you are ready.",
    "2.	Login Details:",
    "       •	Login in EXAMINEE by using your previous credentials to complete your profile.",
    "       •	Once your profile is completed, you'll get a button to login for the final exam that directly takes you to the exam page.",
    "       •	Ensure your device is compatible and web-camera is enabled, and microphone is enabled.",
    "3.	Technical Requirements:",
    "       •	Device: The exam must be taken on a computer or laptop only. Tablets and smartphones are not permitted.",
    "       •	Web Camera: Ensure your web camera is enabled throughout the exam. This is mandatory for proctoring purposes.",
    "       •	Internet Connection: Ensure a stable internet connection to avoid disruptions during the exam.",
    "       •	Browser: Use the latest version of Google Chrome for the best experience.",
    "4.	Exam Environment and Proctoring:",
    "       •	Choose a quiet, well-lit room for the exam.",
    "       •	Ensure no one else is present in the room during the exam.",
    "       •	Clear your desk of any unauthorized materials.",
    "       •	The exam will be proctored live via your web camera. Make sure your camera and microphone always remain on.",
    "       •	The camera should be positioned to provide a clear and comprehensive view of your environment.",
    "       •	The camera should capture not only your face but also a larger view that includes your surroundings (your face, hands, desk where you will be writing detailed solution). This helps in monitoring and maintaining the exam's integrity.",
    "       •	Any suspicious activity may be flagged and reviewed.",
    "5.	Rules and Conduct:",
    "       •	No Cheating: Strictly no cheating or any form of academic dishonesty will be tolerated.",
    "       •	No Communication: Do not communicate with anyone during the exam.",
    "       •	No Unauthorized Materials: You are not allowed to use any textbooks, notes, or electronic devices other than your computer/laptop.",
    "6.	Exam Instructions:",
    "       •	The exam will consist of 25 multiple-choice questions.",
    "       •	Read each question carefully and answer to the best of your ability.",
    "       •	Detailed solution of each question is required. Use A4 sheet. ",
    "       •	After exam is finished, send PDF or images of your solutions via email to statolympiad24@gmail.com mentioning your EXAMINEE ID within 15 minutes, i.e., 11:45 AM. Subject of the email should be: “YOUR_EXAMINEE_ID – Statistics Olympiad – Junior/Senior”",
]

export default function FinalistInstructions() {

    useEffect(() => {
        window.document.title = 'Instructions'
        return () => { window.document.title = process.env.REACT_APP_NAME }
    }, [])

    return (
        <Stack spacing={2} sx={{ wordBreak: "break-all" }} maxWidth={"md"}>
            <Typography variant="h5" fontWeight={"bold"} align="center">
                General Instructions for Finalists
            </Typography>
            {FINALIST_INSTRUCTIONS.length > 0 && FINALIST_INSTRUCTIONS.map((x, index) => (
                <>
                    {x.slice(-1) === ":" ?
                        <Typography key={x} variant="h6" fontWeight={"bold"} sx={{ wordBreak: "break-all" }}>
                            {x}
                        </Typography>
                        :
                        <Typography key={x} variant="subtitle1" sx={{ wordBreak: "break-all" }}>
                            {x}
                        </Typography>
                    }
                </>
            ))}
        </Stack>
    );
}